import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Coordinates } from '@/types/commons/commons.types';
import { OperationalMapId } from '@/types/map.types';

export type MapCommand = { type: 'CENTER'; payload: { center: Coordinates; zoom?: number } };

export type MapsCommandsState = {
  entities: Partial<Record<OperationalMapId, MapCommand>>;
};

const initialState: MapsCommandsState = {
  entities: {},
};

const mapsCommandsSlice = createSlice({
  name: 'mapsCommands',
  initialState,
  reducers: {
    issueMapCommand: (
      state,
      action: PayloadAction<{
        mapId: OperationalMapId;
        command: MapCommand;
      }>,
    ) => {
      state.entities[action.payload.mapId] = action.payload.command;
    },

    clearMapCommand: (state, action: PayloadAction<{ mapId: OperationalMapId }>) => {
      delete state.entities[action.payload.mapId];
    },
  },
});

export const { issueMapCommand, clearMapCommand } = mapsCommandsSlice.actions;

export default mapsCommandsSlice.reducer;
